import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { getAuthUser } from "../services/auth";
import "./Sidebar.css";

const collections = [
  { icon: "fa-solid fa-gauge me-2", label: "Dashboard", path: "/dashboard" },
  {
    icon: "fa-solid fa-folder-open me-2",
    label: "Database Dinas",
    path: "/leads",
  },
  {
    icon: "fa-solid fa-folder-open me-2",
    label: "Database Vendor",
    path: "/databaseVendor",
  },
  {
    icon: "fa-solid fa-folder-open me-2",
    label: "Leads",
    path: "/databaseLeads",
  },
  {
    icon: "fa-solid fa-images me-2",
    label: "Tutorial",
    path: "/tutorial",
  },
  // {
  //   icon: "fa-solid fa-folder-open me-2",
  //   label: "Database Leads",
  //   children: [
  //     { label: "Summary", path: "#" },
  //     { label: "Leads", path: "/databaseLeads" },
  //   ],
  // },
  { icon: "fa-solid fa-user me-2", label: "Users", path: "/users" },
];

const Sidebar = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const auth = getAuthUser();

  useEffect(() => {
    const handleResize = () => {
      setCollapsed(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMenu = (label) => {
    setOpenMenu(openMenu === label ? null : label);
  };

  return (
    <div
      className={`sidebar d-flex flex-column ${collapsed ? "collapsed" : ""}`}
    >
      {/* Header */}
      <div className="sidebar-header d-flex align-items-center justify-content-between p-3">
        <div className="d-flex align-items-center">
          <img
            src="/img/logo.png"
            alt="Logo"
            className="rounded-circle me-4"
            style={{ width: "30px", height: "30px" }}
          />
          {!collapsed && (
            <div>
              <strong>Sariling Group</strong>
            </div>
          )}
        </div>

        <button
          className="btn btn-sm btn-carousel-sidebar"
          onClick={() => setCollapsed(!collapsed)}
        >
          <i className="fa-solid fa-bars text-dark"></i>
        </button>
      </div>

      {/* Menu */}
      <ul className="nav flex-column px-2">
        {collections
          .filter((item) => {
            if (item.label === "Users" && auth?.role !== "super-user") return false;
            if (
              item.label === "Dashboard" &&
              (auth?.role === "tls" || auth?.role === "sales" || auth?.role === "cs-online")
            )
            return false;
            if (item.label === "Leads" && (auth?.role === "cs-online")) return false;
            return true;
          })
          .map((item) => (
            <li key={item.label} className="nav-item mb-1">
              {item.children ? (
                <>
                  <button
                    className={`nav-link d-flex align-items-center w-100 ${
                      openMenu === item.label ? "active" : "text-white"
                    }`}
                    onClick={() => toggleMenu(item.label)}
                  >
                    <span className="icon fs-5">
                      <i className={item.icon}></i>
                    </span>
                    {!collapsed && (
                      <>
                        <span className="ms-2">{item.label}</span>
                        <span className="ms-auto">
                          <i
                            className={`fa-solid fa-chevron-${
                              openMenu === item.label ? "down" : "right"
                            }`}
                          ></i>
                        </span>
                      </>
                    )}
                  </button>
                  {openMenu === item.label && !collapsed && (
                    <ul className="nav flex-column ms-4">
                      {item.children.map((child) => (
                        <li key={child.path} className="nav-item my-1">
                          <Link
                            to={child.path}
                            className={`nav-link ${
                              location.pathname === child.path
                                ? "active"
                                : "text-white"
                            }`}
                          >
                            {child.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              ) : (
                <Link
                  to={item.path}
                  className={`nav-link d-flex align-items-center ${
                    location.pathname === item.path ? "active" : "text-white"
                  }`}
                >
                  <span className="icon fs-5">
                    <i className={item.icon}></i>
                  </span>
                  {!collapsed && <span className="ms-2">{item.label}</span>}
                </Link>
              )}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default Sidebar;
